import { useState } from 'react'
import * as api from '../../lib/api'
import './PinLockScreen.css'

export default function PinSetupScreen({ profile, onComplete }) {
  const [pin, setPin] = useState('')
  const [confirmPin, setConfirmPin] = useState('')
  const [step, setStep] = useState(1) // 1: pin, 2: confirm
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleKeyPress = (digit) => {
    if (loading) return
    setError('')
    if (step === 1) {
      if (pin.length < 4) {
        const newPin = pin + digit
        setPin(newPin)
        if (newPin.length === 4) {
          setTimeout(() => setStep(2), 200)
        }
      }
    } else {
      if (confirmPin.length < 4) {
        const newConfirm = confirmPin + digit
        setConfirmPin(newConfirm)
        if (newConfirm.length === 4) {
          if (pin === newConfirm) {
            savePin(pin)
          } else {
            setError('PIN-коды не совпадают')
            setConfirmPin('')
          }
        }
      }
    }
  }

  const handleBackspace = () => {
    if (loading) return
    setError('')
    if (step === 1) {
      setPin(prev => prev.slice(0, -1))
    } else {
      if (confirmPin.length === 0) {
        setStep(1)
        setPin(prev => prev.slice(0, -1))
      } else {
        setConfirmPin(prev => prev.slice(0, -1))
      }
    }
  }

  const savePin = async (finalPin) => {
    setLoading(true)
    try {
      await api.setPin(profile.id, finalPin)
      onComplete(finalPin)
    } catch (err) {
      setError('Ошибка сохранения PIN')
      setStep(1)
      setPin('')
      setConfirmPin('')
    } finally {
      setLoading(false)
    }
  }

  const currentDots = step === 1 ? pin : confirmPin

  return (
    <div className="pin-lock-overlay">
      <div className="pin-lock-container animate-scale-in">
        <h2 className="pin-lock-title" style={{ marginBottom: '8px' }}>
          {step === 1 ? 'Установите PIN-код' : 'Повторите PIN-код'}
        </h2>
        <div className="pin-lock-subtitle" style={{ marginBottom: '24px' }}>
          Для защиты вашего аккаунта
        </div>

        <div className="pin-lock-dots">
          {[0, 1, 2, 3].map(i => (
            <div key={i} className={`pin-dot ${i < currentDots.length ? 'filled' : ''} ${loading && i < currentDots.length ? 'pulse' : ''}`} />
          ))}
        </div>

        {error && <div className="pin-lock-error">{error}</div>}

        <div className="pin-numpad" style={{ marginTop: '24px' }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(d => (
            <button key={d} className="pin-key" onClick={() => handleKeyPress(String(d))} disabled={loading}>
              {d}
            </button>
          ))}
          <div className="pin-key-placeholder"></div>
          <button className="pin-key" onClick={() => handleKeyPress('0')} disabled={loading}>
            0
          </button>
          <button className="pin-key pin-key-action" onClick={handleBackspace} disabled={loading || currentDots.length === 0}>
            ⌫
          </button>
        </div>
      </div>
    </div>
  )
}
